import { PaginatedSubentityStateModel } from 'app/projects/subentity/src/lib/models/paginated-subentity.state-model';

export class CourseRelevantExecutionsStateModel extends PaginatedSubentityStateModel {
    static identifier = 'CourseRelevantExecutionsStateModel';

    constructor() {
        super(CourseRelevantExecutionsStateModel.identifier);
    }
}
